import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function ThreeDSRedirectScreen() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const threeDsUrl = searchParams.get('3ds_url');

    if (!threeDsUrl) {
      throw new Error('3ds_url query parameter is missing');
    }

    try {
      const url = new URL(threeDsUrl);

      if (!['http:', 'https:'].includes(url.protocol)) {
        throw new Error(
          'Invalid URL protocol. Only HTTP and HTTPS are allowed.'
        );
      }

      if (!url.hostname) {
        throw new Error('Invalid URL: missing hostname');
      }

      if (
        url.hostname === 'localhost' ||
        url.hostname === '127.0.0.1' ||
        url.hostname.startsWith('192.168.') ||
        url.hostname.startsWith('10.') ||
        url.hostname.startsWith('172.')
      ) {
        throw new Error(
          'Invalid URL: localhost or private IP addresses are not allowed'
        );
      }

      window.location.href = threeDsUrl;
    } catch (error) {
      console.error('Invalid URL structure:', error);
      navigate('/');
    }
  }, [searchParams]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Redirigiendo a la autenticación 3DS...</p>
      </div>
    </div>
  );
}
